import * as yup from 'yup'

import allowedJobValues from '../job/allowed.values.js'

import {
  APPLICATIONS_TYPE,
  DEFAULTS,
  SORT_DIRECTION,
  VALIDATION
} from '../constants.js'

export const string = yup.string().trim().min(1, VALIDATION.MESSAGES.REQUIRED)
export const stringNullable = yup.string().trim()
export const date = yup.date()
export const options = yup.array().notEmpty().unique()

export const requiredBool = yup.boolean().required()
export const requiredString = string.required()
export const requiredInteger = yup.number().integer().required()
export const requiredNumber = yup.number().required()
export const requiredPrice = yup.number().positive().decimal(2).required()
export const requiredPercentage = requiredInteger.min(0).max(100)
export const requiredDate = date.required()
export const requiredDatePeriod = yup.array()
  .length(2, VALIDATION.MESSAGES.DATE_PERIOD)
  .of(date.typeError(VALIDATION.MESSAGES.DATE_PERIOD))
  .required()

export const state = string
  .oneOf([...allowedJobValues.states.map(s => s.name), ...allowedJobValues.states.map(s => s.abr)], VALIDATION.MESSAGES.STATE)
  .transform((stateInput) => allowedJobValues.states.find(s => s.abr === stateInput)?.name || stateInput)
export const states = options.of(state)

export const pageNum = yup.number().integer().positive().default(DEFAULTS.PAGE_NUM)
export const pageSize = yup.number().integer().positive().default(DEFAULTS.PAGE_SIZE)
export const userId = requiredString.uuid()
export const schoolId = requiredString.uuid()
export const jobId = requiredString.uuid()
export const role = requiredString
export const status = yup.string().oneOf(Object.values(APPLICATIONS_TYPE)).default(APPLICATIONS_TYPE.PENDING)
export const sortDirection = yup.string().oneOf(Object.values(SORT_DIRECTION)).default(DEFAULTS.SORT_DIRECTION)

export const currentDate = new Date()
export const getFutureDate = (years) => new Date(new Date().setFullYear(new Date().getFullYear() + years))
